import {
  dateTimeFormatter, getLegalEntityName, inRequestInfStatusFormater, localeFormatter, tooltipFormatter,
} from '../../../utils/formatters';

export const informationColumns = [
  {
    dataField: 'created_at',
    text: 'Дата и время',
    formatter: dateTimeFormatter,
  },
  {
    dataField: 'inf_type',
    text: 'Наименование',
    formatter: a => localeFormatter('in_request_inf.type', a),
  },
  {
    dataField: 'status',
    text: 'Статус',
    formatter: inRequestInfStatusFormater,
  },
  {
    dataField: 'status_msg',
    headerClassName: 'status-msg-column',
    text: 'Комментарий',
    formatter: tooltipFormatter,
    disableSort: true,
  },
  {
    dataField: 'api_id',
    text: 'API',
    formatter: item => item || 'ЛК',
  },
  {
    dataField: 'inf_size',
    text: 'Размер данных',
  },
  {
    dataField: 'applicant',
    text: 'Отправитель',
    formatter: getLegalEntityName,
  },
];
